import { Alert, Typography } from 'antd';
import { PageBody, PageHeader } from '../app/AppLayout';

interface PlaceholderPageProps {
  title: string;
  /** Screen id trong 10-ui-screens.md — dùng để tra module và AC của màn này */
  screenId: string;
  /** Sprint và task sẽ dựng màn này, để không ai code sớm rồi lệch thứ tự phụ thuộc */
  plannedIn: string;
}

/**
 * Trang tạm cho các màn chưa tới lượt dựng.
 *
 * Cố ý KHÔNG dựng giao diện gần đúng: dựng nửa vời rồi sẽ có người tưởng là bản thật
 * và chép lại sai. Ở đây chỉ nêu rõ màn này là gì và dựng nó bằng gì.
 */
export function PlaceholderPage({ title, screenId, plannedIn }: PlaceholderPageProps) {
  return (
    <>
      <PageHeader title={title} subtitle={`Màn hình ${screenId}`} />
      <PageBody>
        <Alert
          type="info"
          showIcon
          message="Màn hình chưa được dựng"
          description={
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              {/* Hướng dẫn cho dev (component nào, token ở đâu, tra AC ở file nào) đã bỏ khỏi đây:
                  trang này hiện ra cho người vận hành, mà họ không mở được repo. Chỉ dẫn dành cho
                  dev nằm ở `10-ui-screens.md`, không phải trên màn hình của khách. */}
              Phần này đang được xây dựng và sẽ xuất hiện ở đây khi xong.
              <br />
              Kế hoạch: <strong>{plannedIn}</strong>.
            </Typography.Paragraph>
          }
        />
      </PageBody>
    </>
  );
}
